function initFilterCollection() {
  const scriptElement = document.currentScript;
  const sectionId = scriptElement.getAttribute('data-section-id');
  const sectionElement = document.getElementById(
    'shopify-section-' + sectionId
  );
  const CollectionProductsOverlay = Array.from(
    sectionElement.querySelectorAll('.home-collection-products-overlay')
  );
  if (!sectionElement) return;

  const listCollectionsNode = sectionElement.querySelector(
    '.filter-collection-options'
  );

  const listCollections = Array.from(listCollectionsNode.children);
  CollectionProductsOverlay.forEach((element, index) => {
    if (index == 0) {
      element.classList.remove('hidden');
    } else {
      element.classList.add('hidden');
    }
  });
  listCollections.forEach((element, index) => {
    if (index === 0) element.classList.add('text-secondary', 'border-primary');
    element.addEventListener('click', handleClickOption);
  });

  function handleClickOption(event) {
    const clickedElement = event.target.closest('[data-collection-id]');
    listCollections.forEach((element) => {
      element.classList.remove('text-secondary', 'border-primary');
    });
    if (clickedElement) {
      handleScroll();
      clickedElement.classList.add('text-secondary', 'border-primary');
      const collectionId = clickedElement.getAttribute('data-collection-id');
      const collectionUrl = clickedElement.getAttribute('data-collection-url');
      CollectionProductsOverlay.forEach((element) => {
        if (
          element.getAttribute('data-collection-product-id') === collectionId
        ) {
          element.classList.remove('hidden');
        } else {
          element.classList.add('hidden');
        }
      });
      sectionElement
        .querySelector('.filter-shop-all')
        ?.setAttribute('href', collectionUrl);
    }

    function handleScroll() {
      const containerCenter = listCollectionsNode.clientWidth / 2;
      const elementCenter =
        clickedElement.offsetLeft -
        listCollectionsNode.offsetLeft +
        clickedElement.offsetWidth / 2;
      const scrollLeft = elementCenter - containerCenter;
      listCollectionsNode.scrollTo({
        top: 0,
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }
}
function initSliderCollectionButton(){
  const prevBtn = document.querySelector('#prev-collection-slide-btn');
  const nextBtn = document.querySelector('#next-collection-slide-btn');
  const collectionOptionsOverlay = document.querySelector('#filter-collection-options');

  prevBtn.addEventListener('click', () => {
    collectionOptionsOverlay.scrollBy({
      top: 0,
      left: -300,
      behavior: 'smooth',
    });
  });

  nextBtn.addEventListener('click', () => {
    collectionOptionsOverlay.scrollBy({
      top: 0,
      left: 300,
      behavior: 'smooth',
    });
  });

}
initSliderCollectionButton();
initFilterCollection();
